/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header-background[_ngcontent-%COMP%]{background:url(bac1.168a7def5d4549fa377d.jpg) 0 -320px/cover no-repeat;min-height:190px}.container.bgNav[_ngcontent-%COMP%]{background-color:#00000087}@media screen and (max-width:992px){.header-background[_ngcontent-%COMP%]{background:url(bac1.168a7def5d4549fa377d.jpg) 0 0/cover no-repeat;min-height:70px}}@media screen and (min-width:992px) and (max-width:1200px){.container.bgNav[_ngcontent-%COMP%]{width:100%!important;max-width:100%!important}}"];
export { styles as styles };
